import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { CheckoutSuccess } from './pages/CheckoutSuccess';
import { CheckoutCancel } from './pages/CheckoutCancel';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
import { RequestQuote } from './pages/RequestQuote';
import { Quotes } from './pages/Quotes';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { MonCompte } from './pages/MonCompte';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminProductForm } from './pages/AdminProductForm';
import { Toaster } from 'sonner';
import { toast } from 'sonner';

function App() {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === product.id);
      if (existingItem) {
        return prevCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prevCart, { ...product, quantity: 1 }];
    });
    toast.success('Produit ajouté au panier');
  };

  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity === 0) {
      setCart((prevCart) => prevCart.filter((item) => item.id !== productId));
      toast.success('Produit retiré du panier');
    } else {
      setCart((prevCart) =>
        prevCart.map((item) => (item.id === productId ? { ...item, quantity: newQuantity } : item))
      );
    }
  };

  const removeItem = (productId) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== productId));
    toast.success('Produit retiré du panier');
  };

  const clearCart = () => setCart([]);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar cartCount={cartCount} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produits" element={<Products onAddToCart={addToCart} />} />
            <Route path="/produits/:id" element={<ProductDetail onAddToCart={addToCart} />} />
            <Route path="/panier" element={<Cart cart={cart} onUpdateQuantity={updateQuantity} onRemoveItem={removeItem} />} />
            <Route path="/checkout" element={<Checkout cart={cart} onClearCart={clearCart} />} />
            <Route path="/checkout/success" element={<CheckoutSuccess onClearCart={clearCart} />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/demander-devis" element={<RequestQuote cart={cart} />} />
            <Route path="/devis" element={<Quotes />} />

            {/* Auth */}
            <Route path="/connexion" element={<Login />} />
            <Route path="/inscription" element={<Register />} />

            {/* Client space */}
            <Route
              path="/mon-compte"
              element={
                <ProtectedRoute requireClient>
                  <MonCompte />
                </ProtectedRoute>
              }
            />

            {/* Admin space */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/produits/nouveau"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminProductForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/produits/:id"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminProductForm />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Footer />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
